import { styled } from 'styled-components'

export const Spinner = styled.div`
  display: flex;
  z-index: 1000;
  background-color: transparent;
  border: ${({ color }) => `3px solid ${color}`};
  border-radius: 50%;
  border-top-color: transparent;
  border-right-color: transparent;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  vertical-align: middle;
  box-sizing: border-box;

  @-webkit-keyframes spinner-animation {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @-moz-keyframes spinner-animation {
    0% {
      -moz-transform: rotate(0deg);
    }
    100% {
      -moz-transform: rotate(360deg);
    }
  }
  @-ms-keyframes spinner-animation {
    0% {
      -ms-transform: rotate(0deg);
    }
    100% {
      -ms-transform: rotate(360deg);
    }
  }
  @-o-keyframes spinner-animation {
    0% {
      -o-transform: rotate(0deg);
    }
    100% {
      -o-transform: rotate(100deg);
    }
  }
  @keyframes spinner-animation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  animation:
    spinner-animation 0.65s infinite linear,
    spinner-fade-in 0.3s;
`
